import { ReactNode } from 'react';
import { Link, AnySearch } from '@frontend/weave-router';

type Props = {
  children: ReactNode;
  disabled?: boolean;
  onClick: () => void;
  replace?: boolean;
  search?: AnySearch;
  to?: string;
};

export const AppLink = ({ children, disabled, onClick, replace, to, ...rest }: Props) => (
  <Link onClick={onClick} replace={replace} to={disabled ? undefined : to} {...rest}>
    {children}
  </Link>
);
